import React, { useState } from "react";
import { useAuth } from "./auth";
import FeedsCore from "./FeedsCore";
import "./CampusFeedPage"; // af-* css burada

export default function FeedsReactPage() {
  const { user, loading } = useAuth();
  const [activeTab, setActiveTab] = useState("campus");
  const [composeOpen, setComposeOpen] = useState(true);

  if (loading) return <div className="af-container">Loading...</div>;
  if (!user) return <div className="af-container">Login required.</div>;

  return (
    <FeedsCore
      user={user}
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      composeOpen={composeOpen}
      showTopbar={true}
      onGoProfile={() => (window.location.href = "/profile")}
      onGoDashboard={() => (window.location.href = "/dashboard")}
    />
  );
}